import { Component } from '@angular/core';
import { SimpleModalComponent } from 'ngx-simple-modal';
import { UserService } from "src/app/services/user.service";

export interface ConfirmModel {
  title: string;
  message: string;
}

@Component({
  selector: 'confirm',
  templateUrl: './lgpd.component.html',
  styleUrls: ['./lgpd.component.scss']
})
export class LgpdComponent extends SimpleModalComponent<ConfirmModel, boolean> implements ConfirmModel {
  title: string;
  message: string;

  constructor(
    private userService: UserService
  ) {
    super();
  }

  confirm() {
    this.userService.confirmLgpd().subscribe(
			(res) => {},
			(err) => {}
		);

    this.close();
  }

}

